module.exports = __webpack_public_path__ + "img/icon-settings.db17081a.svg";